import React, { useEffect, useState } from "react";
import BookInfo from "./BookModule.module.css";

import {
  CurrencyRupee,
  HeartBrokenSharp,
  HeartBrokenTwoTone,
} from "@mui/icons-material";
import { Favorite, Star } from "@material-ui/icons";

import DeafultImage from "./Default.jpg";
import pdfIamge from "./pdf.png";

import { Link, useNavigate } from "react-router-dom";
import { ImageUrlPrefix } from "../../../../labels";

export default function CardTemplate({
  items,
  toggleWish,
  handleSubmitCart,
  tagsFilter,
  handleTagsFilter,
  isSet,
}) {
  const navigate = useNavigate();
  const images =
    items?.images?.length > 0
      ? items.images.map((op) => `${ImageUrlPrefix}/${op.book_image_path}`)
      : items.is_ebook == 1
      ? [pdfIamge]
      : [DeafultImage];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // To control when the slideshow starts

  useEffect(() => {
    let interval;
    // Start the slideshow only when hovered
    if (isHovered) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 2000); // Slide changes every 3 seconds
    }
    return () => {
      clearInterval(interval); // Clear the interval when unhovered or component unmounts
    };
  }, [isHovered, images.length]);

  const handleMouseEnter = () => {
    setIsHovered(true); // Start slideshow on hover
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };
  const handleViewAbooksnav = (book_id) => {
    navigate(`/ViewBook/${book_id}`);
  };

  return (
    <div
      class={BookInfo.cardContainer}
      onClick={() => handleViewAbooksnav(items.id)}
    >
      <div className={`row mx-0`}>
        <div className="px-0 col-md-12 d-flex">
          <div
            className={`col-md-6 col-6 col-xs-6 col-sm-6 ${BookInfo.dots_navigation}`}
          >
            <ul className="d-flex mb-0">
              {images?.map((_, index) => (
                <li
                  key={index}
                  className={
                    currentIndex === index ? `${BookInfo.active_dot}` : ``
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDotClick(index);
                  }}
                ></li>
              ))}
            </ul>
          </div>
          <div
            className={`col-md-6 col-6 col-xs-6 col-sm-6 d-flex flex-row justify-content-end `}
          >
            {items.overall_ratings > 0 && (
              <div className={BookInfo.ratings_star_icon}>
                <p className={`${BookInfo.rating_title} mb-0`}>
                  {items.overall_ratings}
                  <Star className={BookInfo.star_icon} />
                </p>
              </div>
            )}

            <Favorite
              className={
                items.is_wishlist == 1
                  ? `${BookInfo.heart_wishlist_icon_active}`
                  : `${BookInfo.heart_wishlist_icon}`
              }
              onClick={(e) => {
                e.stopPropagation();
                toggleWish(items.id, items.is_wishlist);
              }}
            />
          </div>
        </div>
      </div>

      <div
        className={`row mx-0 padding_10_0 text-center ${BookInfo.BookborderRed} `}
        onMouseEnter={handleMouseEnter} // Pause on hover
        onMouseLeave={handleMouseLeave} // Resume on leave
      >
        <div
          className={`px-0 col-md-12 col-12 col-lg-12  ${BookInfo.height_default_img_sec}`}
        >
          <img
            src={images[currentIndex]}
            alt="Book Image"
            className={`${BookInfo.bookImage}`}
          />
        </div>
      </div>

      <div className={`row mx-0 padding_10_0 ${BookInfo.BookborderRed}`}>
        <div className={`px-0 col-md-12 `}>
          <p
            title={items.book_title}
            className={`${BookInfo.ellipsis_book} text-center ${BookInfo.BookTitle}`}
          >
            {items.is_set == 1
              ? items.book_title
                ? `${items.book_title} ${
                    items.no_of_books
                      ? ` (Set of ${items.no_of_books} Books)`
                      : ""
                  }`
                : ""
              : items.book_title
              ? items.book_title
              : ""}
          </p>
          {/* <p

            className={`mb-0 ${BookInfo.BookSubTitle} text-center`}
          >
            {items.author ? items.author : ""}
          </p>
          {console.log(items, "items000000")
          } */}
        </div>
        <div className={`p-0 ${BookInfo.titleHeight}`}>
          <p
            className={`mb-0 ${BookInfo.BookSubTitleHeight} ${BookInfo.BookSubTitle} `}
          >
            {items.tag_line ? items.tag_line : ""}
          </p>
        </div>
      </div>

      <div className={`row mx-0 padding_10_0 ${BookInfo.BookborderRed}`}>
        <div className={`px-0 col-md-12 d-flex ${BookInfo.priceTagSection}`}>
          <div className={` col-xl-7 col-lg-7 col-md-7 col-12 col-sm-12 `}>
            <p className={`mb-0 text-start`}>
              <span className={BookInfo.item_price}>
                {" "}
                <span className={BookInfo.rupees_icon}>&#8377;</span>
                {items.finalPrice}
              </span>
              {items.offer_percentage > 0 && (
                <>
                  <span className={BookInfo.item_price_disAmount}>
                    {items.price}
                  </span>
                  <span className={BookInfo.item_price_offer}>
                    {" "}
                    {items.offer_percentage}% off
                  </span>
                </>
              )}
            </p>
          </div>

          {
            // (items.is_ebook == 0 &&
            //   items.is_set == 0 &&
            //   items.is_pre_order == 0) ||
            // items.is_set == 0 ? (
            //   <div className={` col-xl-5 col-lg-5 col-md-5 col-12 col-sm-12`}>
            //     {items.stock_count === 0 &&
            //     items.is_set == 0 &&
            //     items.is_ebook == 0 ? (
            //       <p
            //         className={`${BookInfo.stock_item_right_label} text-center mb-0`}
            //       >
            //         Out of Stock
            //       </p>
            //     ) : items.stock_count > 0 &&
            //       items.stock_count < 10 &&
            //       items.is_set == 0 ? (
            //       <p
            //         className={`${BookInfo.stock_item_right_label} text-center mb-0`}
            //       >
            //         {`Only ${items.stock_count} ${
            //           items.stock_count > 1 ? `books` : `book`
            //         } left`}
            //       </p>
            //     ) : items.stock_count === 0 &&
            //       items.is_set == 1 &&
            //       items.availableToUser == 0 ? (
            //       <p
            //         className={`${BookInfo.stock_item_right_label} text-center mb-0`}
            //       >
            //         Out of Stock
            //       </p>
            //     ) : (
            //       ""
            //     )}{" "}
            //   </div>
            // ) : (
            //   <div className={` col-xl-5 col-lg-5 col-md-5 col-12 col-sm-12`}>
            //     {items.is_pre_order == 1 ? (
            //       <p
            //         className={`${BookInfo.stock_item_right_label} text-center mb-0`}
            //       >
            //         Pre-order
            //       </p>
            //     ) : (
            //       ""
            //     )}
            //   </div>
            // )
            <div className="col-xl-5 col-lg-5 col-md-5 col-12 col-sm-12">
              {items.is_ebook === 1 ? (
                <p
                  className={`${BookInfo.stock_item_right_label} text-center mb-0`}
                >
                  E-Book
                </p>
              ) : items.is_pre_order === 1 && isSet === 1 ? (
                <p
                  className={`${BookInfo.stock_item_right_label} text-center mb-0`}
                >
                  Pre-order
                </p>
              ) : items.is_ebook === 0 && items.is_set === 0 ? (
                items.stock_count <= 0 ? (
                  <p
                    className={`${BookInfo.stock_item_right_label} text-center mb-0`}
                  >
                    Out of Stock
                  </p>
                ) : items.stock_count > 0 && items.stock_count < 10 ? (
                  <p
                    className={`${BookInfo.stock_item_right_label} text-center mb-0`}
                  >
                    {`Only ${items.stock_count} ${
                      items.stock_count > 1 ? "books" : "book"
                    } left`}
                  </p>
                ) : null
              ) : items.is_set === 0 &&
                items.stock_count <= 0 &&
                items.availableToUser === 0 ? (
                <p
                  className={`${BookInfo.stock_item_right_label} text-center mb-0`}
                >
                  Out of Stock
                </p>
              ) : null}
            </div>
          }
        </div>
      </div>

      <div className={`row  mx-0 padding_10_0 ${BookInfo.BookborderRed}`}>
        <div
          className={`px-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ${BookInfo.height_default_tag_sec}`}
          style={{ overflow: "hidden" }}
        >
          <ul className={` p-0 m-0 d-flex flex-wrap ${BookInfo.BookTagchip}`}>
            {Array.isArray(items?.tags) && items?.tags.length > 0 && (
              <>
                {items?.tags.slice(0, 8).map((op, index) => (
                  <li key={index}>
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        handleTagsFilter(op.tag_id, op.tag_name);
                      }}
                      href="javascript:void(0)"
                      className={BookInfo.BookTagChipLabel}
                      title={op.tag_name}
                    >
                      {op.tag_name}
                    </a>
                  </li>
                ))}
                {items?.tags.length > 8 && (
                  <li className={BookInfo.BookTag_MoreChipLabel}>
                    + {items?.tags.length - 8} more
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
      <div className="row mx-0">
        <div className="px-0 mt-2 col-xl-12 col-lg-12 col-md-12 col-12 ">
          {/* <Link
            to="javascript:void(0)"
            onClick={
              items.is_cartlist == 1 ||
              (items.stock_count == 0 &&
                items.is_ebook == 0 &&
                items.is_set == 0) ||
              (items.stock_count == 0 &&
                items.availableToUser == 0 &&
                items.is_set == 1) ||
              (items.is_visible == 0 && items.is_set == 0) ||
              items.is_pre_order == 1
                ? () => {}
                : () => handleSubmitCart(items.id)
            }
            className={`primaryButton text-center ${BookInfo.fullWidthButton} ${
              items.is_cartlist == 1 ||
              (items.stock_count == 0 &&
                items.is_ebook == 0 &&
                items.is_set == 0) ||
              (items.stock_count == 0 &&
                items.availableToUser == 0 &&
                items.is_set == 1) ||
              (items.is_visible == 0 && items.is_set == 0) ||
              items.is_pre_order == 1
                ? "disabled_btn"
                : ""
            }  `}
            variant="primary"
          >
            {isAddedToCart || items.is_cartlist == 1
              ? "Go to Cart"
              : "Add to Cart"}
          </Link> */}
          {/* <Link
            to="javascript:void(0)"
            onClick={
              items.is_cartlist == 1
                ? () => navigate("/AddToCart") // Redirect to cart page if already added
                : () => handleSubmitCart(items.id) // Otherwise, add to cart
            }
            className={`primaryButton text-center ${BookInfo.fullWidthButton}
            ${
              isAddedToCart || items.is_cartlist == 1
                ? "goToCartStyle"
                : "addToCartStyle"
            }`}
            variant="primary"
          >
            {isAddedToCart || items.is_cartlist == 1
              ? "Go to Cart"
              : "Add to Cart"}
          </Link> */}
          <Link
            to="javascript:void(0)"
            onClick={(e) => {
              e.stopPropagation();
              if (items.is_cartlist === 1) {
                navigate("/AddToCart");
              } else if (
                (items.is_ebook === 0 &&
                  items.is_set === 0 &&
                  items.stock_count <= 0) ||
                (items.availableToUser === 0 &&
                  items.is_set === 1 &&
                  items.stock_count <= 0) ||
                (items.is_visible === 0 && items.is_set === 0) ||
                items.is_pre_order === 1
              ) {
                return;
              } else {
                handleSubmitCart(items.id);
              }
            }}
            className={`primaryButton text-center ${BookInfo.fullWidthButton} ${
              (items.is_ebook === 0 &&
                items.is_set === 0 &&
                items.stock_count <= 0) ||
              (items.availableToUser === 0 &&
                items.is_set === 1 &&
                items.stock_count <= 0) ||
              (items.is_visible === 0 && items.is_set === 0) ||
              items.is_pre_order === 1
                ? "disabled_btn"
                : ""
            } ${
              items.is_cartlist === 1
                ? `${BookInfo.goToCartStyle}`
                : `${BookInfo.addToCartStyle}`
            }`}
            variant="primary"
          >
            <span className={BookInfo.buttonText}>
              {items.is_cartlist === 1 ? "Go to Cart" : "Add to Cart"}
            </span>
            <span className={BookInfo.arrowIcon}>&rarr;</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
